import { Skeleton } from "@circleco/compass/components/Skeleton";

export const SearchResultSkeletonRow = () => (
  <li className="flex w-full list-none items-center gap-3 px-3 py-2">
    <Skeleton shape="pill" className="size-6 shrink-0" />
    <Skeleton shape="rounded" className="h-4 w-1/2" />
  </li>
);
